import getRid from "./getRid";

const addRidToParameters = (additionalParameters: Record<string, string>) => ({
  ...additionalParameters,
  rid: getRid(),
});

export default addRidToParameters;
